<template lang="html">
  <div class="iframe-wrapper">
    <transition name="fade">
      <div v-if="pageLoading" class="page-loading">
        <div class="loader">
          <Sprite name="gear"/>
        </div>
      </div>
    </transition>

    <iframe
      class="preview-iframe"
      :src="iframeSrc"
      id="site-previewer-iframe"
      frameborder="0">
    </iframe>
  </div>
</template>

<script>
import Sprite from '@/components/Sprite'

export default {
  components: {
    Sprite
  },

  props: {
    iframeSrc: String,
    pageLoading: Boolean
  }
}
</script>

<style lang="sass">
  .preview-iframe
    width: 100%
    height: 100%
    border-radius: 20px
    background: #fff
    box-shadow: 0 0 50px rgba(0, 0, 0, 0.15)
    transition: background .3s ease-in-out

  .site-builder
    .iframe-wrapper
      position: relative
      height: 100%
      width: 100%
      padding: 30px
      margin: auto

      .loader
        background: #fff
        border-radius: 20px
        height: calc(100% - 60px)
        width: calc(100% - 60px)
        left: 50%
        transform: translateX(-50%)
</style>
